import availableShirtSizes from '@/helpers/shirtSizeHelper'
import availableSizes from '@/helpers/sizeHelper'
import availableHairColors from '@/helpers/hairColorHelper'
import availableEthnicities from '@/helpers/ethnicityHelper'
import {
    availableCastingJobTypes,
    availableMasterOfCeremoniesJobTypes,
    availableEventSupportJobTypes,
    availableBarsRestaurantsJobTypes
} from '@/helpers/availableJobTypeHelper'
import availableLanguages from '@/helpers/availableLanguagesHelper'
import availableEducationLevels from '@/helpers/availableEducationLevelsHelper'

export default function() {
    return {
        openProfile: 0,
        availableShirtSizes,
        availableSizes,
        availableHairColors,
        availableEthnicities,
        allAvailableJobTypes: [
            ...availableCastingJobTypes,
            ...availableMasterOfCeremoniesJobTypes,
            ...availableEventSupportJobTypes,
            ...availableBarsRestaurantsJobTypes
        ],
        availableLanguages,
        availableEducationLevels,
        profiles: [],
        showRatingComments: false,
        showZoomMedia: false,
        zoomMedia: {},
        currentMedia: null,
        copyToClipboardTooltip: 'Copiar link',
        completedCourseDetails: {
            show: false,
            image: null,
            name: null,
            description: null
        },
        showVaccinationCertificateBadge: false
    }
}
